export const referenceDataKeys = {
  // Prefix for invalidating every REFERENCE_DATA query (react-query v3 prefix match).
  all: ['REFERENCE_DATA'] as const,
  detail: (documentId: number | string, referenceDataId: string) => ['REFERENCE_DATA', documentId, referenceDataId],
  byRevision: (revisionId: string) => ['REFERENCE_DATA', { revisionId }],
  // Shared by the translations query and the xliff-upload mutation key (legacy shape).
  forDocument: (documentSuperId?: number | string) => ['REFERENCE_DATA', documentSuperId],
  // Prefix for invalidating every reference-data list query.
  listAll: ['REFERENCE_DATA_LIST'] as const,
  list: (documentSuperId: number | string | undefined, referenceRevisionIds: string) => ['REFERENCE_DATA_LIST', documentSuperId, referenceRevisionIds],
  parsedSheet: (revisionId: string, selectedSheet: unknown, locale: string) => ['PARSED_SHEET', revisionId, { selectedSheet, locale }],
  xlsxFile: (fileRevisionId: string) => ['XLSX_FILE', fileRevisionId],
  // Prefix for invalidating every xlsx-files query.
  xlsxFilesAll: ['XLSX_FILES'] as const,
  xlsxFiles: (documentId: number | string) => ['XLSX_FILES', documentId],
};
